/* eslint-disable indent */
import React, { createContext, useReducer, useEffect } from 'react';

import { getReferenceData } from '../services/reference-data.service';

const Reducer = (state, action) => {
  switch (action.type) {
    case 'SET_FORMATS': {
      const formatList = [];
      const publishers = [];
      const map = new Map();
      for (const item of action.payload) {
        if (!map.has(item.mediaOwnerId)) {
          map.set(item.mediaOwnerId, true); // set any value to Map
          publishers.push({ id: item.mediaOwnerId, value: item.mediaOwnerId, name: item.mediaOwnerName, country: item.country });
        }
        if (item.id) {
          formatList.push(item);
        }
      }

      return {
        ...state,
        formats: formatList,
        publishers
      };
    }
    case 'SET_AGENCIES':
      return {
        ...state,
        agencies: action.payload.map(q => ({ id: q.id, value: q.id, name: q.name }))
      };
    case 'SET_CREATIVE_AGENCIES':
      return {
        ...state,
        creativeAgencies: action.payload.map(q => ({ id: q.id, value: q.id, name: q.name }))
      };
    case 'SET_ADVERTISERS':
      return {
        ...state,
        advertisers: action.payload.map(q => ({ id: q.id, value: q.id, agencyId: q.agencyId, name: q.name }))
      };
    case 'SET_DSPS':
      return {
        ...state,
        dsps: action.payload.map(q => ({ id: q.id, value: q.id, name: q.name, country: q.country }))
      };
    case 'SET_COUNTRY':
      return {
        ...state,
        country: action.payload
      };
    case 'SET_SUPER_USER':
      return {
        ...state,
        superUser: action.payload
      };
    case 'SET_ACCESS':
      return {
        ...state,
        access: action.payload
      };
    case 'SET_DASHBOARD3':
      return {
        ...state,
        dashboard3: action.payload
      };
    case 'SET_LOADED':
      return {
        ...state,
        loading: false
      };
    case 'INCREMENT_REFRESH':
      return {
        ...state,
        refresh: (state.refresh + 1)
      };
    default:
      return state;
  }
};

const initialState = {
  formats: [],
  agencies: [],
  creativeAgencies: [],
  advertisers: [],
  publishers: [],
  dsps: [],
  country: '',
  access: [],
  superUser: false,
  loading: true,
  refresh: 0,
  dashboard3: []
};

const GlobalStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  // const memoizedState = useMemo(() => [state, dispatch], [state])

  // global init - get default data required throughout the application
  useEffect(() => {
    getReferenceData()
      .catch(_err => null)
      .then(res => {
        if (res && res.status === 200) {
          dispatch({ type: 'SET_FORMATS', payload: (res.data.formats || []) });
          dispatch({ type: 'SET_ADVERTISERS', payload: (res.data.advertisers || []) });
          dispatch({ type: 'SET_AGENCIES', payload: (res.data.agencies || []) });
          dispatch({ type: 'SET_CREATIVE_AGENCIES', payload: (res.data.creativeAgencies || []) });
          dispatch({ type: 'SET_DSPS', payload: (res.data.dsps || []) });
          dispatch({ type: 'SET_COUNTRY', payload: (res.data.country || '') });
          dispatch({ type: 'SET_ACCESS', payload: (res.data.access || []) });
          dispatch({ type: 'SET_SUPER_USER', payload: (res.data.superUser || false) });
          dispatch({ type: 'SET_DASHBOARD3', payload: (res.data.dashboard3 || []) });
        }
      })
      .finally(_ => dispatch({ type: 'SET_LOADED' }));
  }, []);

  useEffect(() => {
    if (state.refresh > 0) {
      getReferenceData()
        .catch(_err => null)
        .then(res => {
          if (res && res.status === 200) {
            dispatch({ type: 'SET_FORMATS', payload: (res.data.formats || []) });
            dispatch({ type: 'SET_ADVERTISERS', payload: (res.data.advertisers || []) });
            dispatch({ type: 'SET_AGENCIES', payload: (res.data.agencies || []) });
            dispatch({ type: 'SET_CREATIVE_AGENCIES', payload: (res.data.creativeAgencies || []) });
            dispatch({ type: 'SET_DSPS', payload: (res.data.dsps || []) });
            dispatch({ type: 'SET_COUNTRY', payload: (res.data.country || '') });
            dispatch({ type: 'SET_ACCESS', payload: (res.data.access || []) });
            dispatch({ type: 'SET_SUPER_USER', payload: (res.data.superUser || false) });
            dispatch({ type: 'SET_DASHBOARD3', payload: (res.data.dashboard3 || []) });
          }
        });
      }
  }, [state.refresh]);

  return (
    <GlobalStoreContext.Provider value={[ state, dispatch ]}>
      {children}
    </GlobalStoreContext.Provider>
  )
};

// export const GlobalStoreContext = createContext(initialState);
export const GlobalStoreContext = createContext({ state: initialState, dispatch: () => null });

export default GlobalStore;
